// Trial overview search filters. Keys match the POST /trials parameters; values are kept as
// strings ('' = not set) so they round-trip through the URL unchanged.
export const EMPTY_TRIAL_FILTERS = {
  q: '',
  trial: '',
  location: '',
  contract_no: '',
  year: '',
  customer_id: '',
  country_id: '',
  host_id: '',
  crop_id: '',
  study_type_id: '',
  trial_type_id: '', // one or more ids, comma-separated ("1,3")
  sd_id: '',
  pi_id: '',
  ft_id: '',
};

// Typed by the user - debounced before they are sent to the API
export const TEXT_FILTER_KEYS = ['q', 'trial', 'location', 'contract_no'];

const FILTER_KEYS = Object.keys(EMPTY_TRIAL_FILTERS);

export function filtersFromSearchParams(searchParams) {
  const filters = { ...EMPTY_TRIAL_FILTERS };
  for (const key of FILTER_KEYS) {
    filters[key] = searchParams.get(key) ?? '';
  }
  return filters;
}

// Only the filters that are set, e.g. for the URL or the request payload
export function activeFilters(filters) {
  const active = {};
  for (const key of FILTER_KEYS) {
    const value = String(filters[key] ?? '').trim();
    if (value !== '') active[key] = value;
  }
  return active;
}

export function hasActiveFilters(filters) {
  return Object.keys(activeFilters(filters)).length > 0;
}
